import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";
import { IFilterParameterComponent } from "./filter-parameter.component";
import { FilterParameterModel } from "./models/filter-parameter.model";

export class FilterMultichoiceListParameterComponent extends EventEmitterMixin(EmptyInstance) implements IFilterParameterComponent {
    public static SELECTOR: string = ".js-ina-filter-multichoice-list-parameter";

    private _currentContext: JQuery = $();

    private _classMap = {
        js: {
            option: `${FilterMultichoiceListParameterComponent.SELECTOR}__option`,
            value: `${FilterMultichoiceListParameterComponent.SELECTOR}__value`
        }
    };

    private _options: JQuery;
    private _value: JQuery;

    public getName(): string {
        return this._value.attr("name");
    }

    public reset(value?: string): IFilterParameterComponent {
        if(!value) {
            this.setValue([]);
            this._options.each((index: number, element: HTMLInputElement) => {
                element.checked = false;
            });
        } else {
            const arrayVal = this.fromStringValue(value);
            this.setValue(arrayVal);
        }
        return this;
    }

    public getValue(): Array<string> {
        const valueStr = this._value.val() as string;
        const value = this.fromStringValue(valueStr);
        return value;
    }

    public getParam(): FilterParameterModel {
        return {
            name: this.getName(),
            sortOrder: this.sortOrder(),
            value: this.getValue().map(value => {
                return {
                    name: this.stringifyValue(value),
                    data: value,
                    sortOrder: this._options.filterByData("value", value).data("sortOrder") as number
                };
            })
        };
    }

    public setValue(value: Array<string>): FilterMultichoiceListParameterComponent {
        const valueStr = this.toStringValue(value);
        this._value.val(valueStr);
        this._options.each((index, entry) => {
            const option = $(entry);
            const data = option.data();
            const optionValue = `${data.value as string}`;

            const optionIndex = value.indexOf(optionValue);
            if (optionIndex > -1) {
                (option.get(0) as HTMLInputElement).checked = true;
            } else {
                (option.get(0) as HTMLInputElement).checked = false;
            }
        });

        this.emit("changed", this.getParam());

        return this;
    }

    public isEmpty(): boolean {
        return !this.getValue().length;
    }

    public stringifyValue(value: string): string {
        let str = "";
        this._options.each((index, entry) => {
            const option = $(entry);
            const data = option.data();
            if (`${data.value as string}` === value) {
                str = data.displayName as string;
            }
        });

        return str;
    }

    public sortOrder(): number {
        return this._currentContext.data().sortOrder as number;
    }

    public setInitialValue(): void {
        const initialValueStr = this._value.val() as string;
        if (initialValueStr !== undefined && initialValueStr !== "") {
            const initialValue = this.fromStringValue(initialValueStr);
            this.setValue(initialValue);
        }
    }

    private toStringValue(value: Array<string>): string {
        return value.join(",");
    }

    private fromStringValue(valueStr: string): Array<string> {
        return valueStr ? valueStr.split(",") : [];
    }

    private handleOptionClick(option: JQuery): void {
        const optionValue = `${option.data().value as string}`;
        const controlValue = this.getValue();

        if ((option.get(0) as HTMLInputElement).checked) {
            controlValue.push(optionValue);
        } else {
            const index = controlValue.indexOf(optionValue);
            if (index > -1) {
                controlValue.splice(index, 1);
            }
        }

        this.setValue(controlValue);
    }

    public removeValue(value: string): void {
        const controlValue = this.getValue();
        const index = controlValue.indexOf(value);
        if (index > -1) {
            controlValue.splice(index, 1);
        }

        this.setValue(controlValue);
    }

    private bindEvents(): void {
        this._options.on("click", e => {
            const option = $(e.target);
            this.handleOptionClick(option);
        });
    }

    private parseContext(): void {
        this._options = $(this._classMap.js.option, this._currentContext);
        this._value = $(this._classMap.js.value, this._currentContext);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
        // this.setInitialValue();
    }
}
